// extracted by mini-css-extract-plugin
module.exports = {"default":"PostGrid--default--1iA37","post":"PostGrid--post--16DhK"};